import { observer } from "mobx-react-lite";
import { Outlet } from "react-router-dom";

import { envVarStore } from "../../utils/mobx/EnvVarStore";

const Layout = observer(() => {
  const { headerAndSidebar } = envVarStore;

  const contentWidth =
    headerAndSidebar === "true" ? "calc(100vw - 284px)" : "100vw";
  const contentHeight =
    headerAndSidebar === "true" ? "calc(100vh - 56px)" : "100vh";

  return (
    <div
      style={{
        width: contentWidth,
        height: contentHeight,
        overflow: "hidden",
      }}
    >
      <div className="flex h-full">
        <div className="flex w-full flex-col overflow-y-auto">
          <Outlet />
        </div>
      </div>
    </div>
  );
});

export default Layout;
